/**
 * Maintained by Sandon.
 */
import SyOption from '../select/src/option.js'
export default SyOption
